import { categoriesUrl } from "../resources";
import postRequest from '../common/postRequest.js';
import putRequest from '../common/putRequest.js'

async function createCategory(data, token) {
    let url = `${categoriesUrl}`;
    return await postRequest.postDataWithToken(url, data, token); 
}

async function updateCategory(data, categoryId, token) {
    
    let url = `${categoriesUrl}/${categoryId}`;
    await putRequest.putDataWithToken(url, data, token);

}

export default { 
    createCategory,
    updateCategory
}